import type { ChartColorPaletteId } from './types';

export const CHART_COLOR_PALETTES: Record<ChartColorPaletteId, string[]> = {
  default: ['#42a5f5', '#66bb6a', '#ffa726', '#ef5350', '#ab47bc', '#26c6da', '#ffca28', '#8d6e63'],
  earth: ['#5d4037', '#8d6e63', '#a1887f', '#6d4c41', '#4e342e', '#795548', '#bcaaa4', '#3e2723'],
  vivid: ['#d32f2f', '#c2185b', '#7b1fa2', '#303f9f', '#1976d2', '#00796b', '#f57c00', '#e64a19'],
  neon: ['#00e5ff', '#76ff03', '#ffea00', '#ff4081', '#7c4dff', '#69f0ae', '#ffd740', '#448aff'],
  pastel: ['#90caf9', '#a5d6a7', '#ffcc80', '#ef9a9a', '#ce93d8', '#80cbc4', '#fff59d', '#d7ccc8'],
  ocean: ['#0077b6', '#00b4d8', '#48cae4', '#90e0ef', '#023e8a', '#0096c7', '#ade8f4', '#caf0f8'],
  sunset: ['#ff6b6b', '#ee5a24', '#f9ca24', '#ff9ff3', '#f368e0', '#ff9f43', '#feca57', '#c44569'],
  midnight: ['#6c5ce7', '#a29bfe', '#0984e3', '#74b9ff', '#2d3436', '#636e72', '#b2bec3', '#dfe6e9'],
  cyber: ['#00f5d4', '#00bbf9', '#fee440', '#f15bb5', '#9b5de5', '#00f5d4', '#fb5607', '#3a86ff'],
  forest: ['#2d6a4f', '#40916c', '#52b788', '#74c69d', '#95d5b2', '#b7e4c7', '#1b4332', '#344e41'],
  autumn: ['#bc6c25', '#dda15e', '#606c38', '#283618', '#9b2226', '#ae2012', '#bb3e03', '#ca6702'],
  berry: ['#7b2d8e', '#c2185b', '#e91e63', '#f06292', '#880e4f', '#ad1457', '#d81b60', '#ec407a'],
  retro: ['#e07a5f', '#3d405b', '#81b29a', '#f2cc8f', '#264653', '#2a9d8f', '#e9c46a', '#f4a261'],
  tropical: ['#06d6a0', '#118ab2', '#ef476f', '#ffd166', '#073b4c', '#26547c', '#ff6b6b', '#06ba63'],
  slate: ['#495057', '#6c757d', '#adb5bd', '#dee2e6', '#343a40', '#868e96', '#ced4da', '#212529'],
  candy: ['#ff6f91', '#ff9671', '#ffc75f', '#f9f871', '#d65db1', '#845ec2', '#ff5e78', '#00c9a7'],
  jewel: ['#50c878', '#0f52ba', '#e0115f', '#9966cc', '#e6be8a', '#00416a', '#b80f0a', '#4b0082'],
};

export const CHART_PALETTE_LABELS: Record<ChartColorPaletteId, string> = {
  default: 'Default',
  earth: 'Earth / muted',
  vivid: 'Vivid',
  neon: 'Neon',
  pastel: 'Pastel',
  ocean: 'Ocean',
  sunset: 'Sunset',
  midnight: 'Midnight',
  cyber: 'Cyber',
  forest: 'Forest',
  autumn: 'Autumn',
  berry: 'Berry',
  retro: 'Retro',
  tropical: 'Tropical',
  slate: 'Slate / greyscale',
  candy: 'Candy',
  jewel: 'Jewel tones',
};

export const CHART_PALETTE_IDS = Object.keys(CHART_COLOR_PALETTES) as ChartColorPaletteId[];
